// extracted by mini-css-extract-plugin
export default {"wrap":"LH-z","fullWidth":"MH-z","hideOnDesktop":"NH-z","content":"OH-z","hasOpenedNav":"PH-z","crumbsList":"QH-z","dropdownsWrap":"RH-z"};